@if (process) {
  <div class="container pt-3">
    <rbb-side-menu-headline headline="{{process.formName}}" icon="fas fa-file-alt" class="no-print"/>
    <h3 class="mb-0 mt-3 mb-4 only-print">{{process.formName}}</h3>

    @if (isActiveApproval.length) {
      <div class="my-4 no-print">
        {{ isActiveApproval[0].forInformationOnly ? 'Zur Kenntnis nehmen' : 'Genehmigung' }}
        @if (isActiveApproval[0].username !== webAuthService.authUser?.username) {<span class="fw-bold text-underline">stellvertretend</span>}
        @if (!isActiveApproval[0].forInformationOnly) { erteilen } als
        @for (approval of isActiveApproval; track approval.id; let i = $index) {
          @if (i !== 0 && i === isActiveApproval.length - 1) { und }
          @if (i !== 0 && i < isActiveApproval.length - 1) {, }
          @if (approval.approverType === ApproverType.CHIEF || approval.approverType === ApproverType.CHIEF_AND_DEPUTY) {Vorgesetzte/r}
          @if (approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE || approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY) {Kostenstellenverantwortliche/r}
          @if (approval.approverType === ApproverType.DEPARTMENT_CHIEF || approval.approverType === ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY) {Abteilungsleiter/in}
          @if (approval.approverType === ApproverType.MAIN_DEPARTMENT_CHIEF || approval.approverType === ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY) {HA Leiter/in}
          @if (approval.approverType === ApproverType.DIRECTOR || approval.approverType === ApproverType.DIRECTOR_AND_DEPUTY) {Direktor/in}
          @if (approval.approverType === ApproverType.DESIGNATED_APPROVER) {Festgelegte/r Genehmiger/in}
          @if (approval.approverType === ApproverType.APPROVER_GROUP) {Mitglied der Genehmigergruppe: }
        }
        {{isActiveApproval[0].firstName}} {{isActiveApproval[0].lastName}}
        @if (isActiveApproval[0].username === webAuthService.authUser?.username || isActiveApproval[0].deputyUsername === webAuthService.authUser?.username) {
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalApprove(false)"><i class="fas fa-check" aria-hidden="true"></i>&ensp;{{ isActiveApproval[0].forInformationOnly ? 'Zur Kenntnis nehmen' : 'Genehmigen' }}</button>
        }
        @if (!isActiveApproval[0].forInformationOnly) {
          <button style="min-width: 130px" class="btn btn-sm btn-danger ms-3 fw-bold" (click)="openModalApprove(true)"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Ablehnen</button>
        }
      </div>
    }
    @if (employee?.admin || process.operator) {
      <div class="my-4 no-print">
        @if (process.status === ProcessStatus.APPROVED && (!process.actionType || process.actionType === ActionType.EMAIL)) {
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalOperator()">In Bearbeitung versetzen</button>
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalResubmit()">Wiedervorlage</button>
        }
        @if (process.status === ProcessStatus.APPROVED && process.actionType && process.actionType !== ActionType.EMAIL) {
          <button style="min-width: 130px" class="btn btn-sm btn-danger ms-3 fw-bold" (click)="failTransmission()">Übermittlung abbrechen</button>
        }
        @if (process.status === ProcessStatus.IN_PROGRESS) {
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalOperator()"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Bearbeitung abschließen</button>
          <button style="min-width: 130px" class="btn btn-sm btn-danger ms-3 fw-bold" (click)="openModalReject()"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Bearbeitung zurückweisen</button>
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalResubmit()">Wiedervorlage</button>
        }
        @if (process.status === ProcessStatus.FINISHED || process.status === ProcessStatus.REJECTED || process.status === ProcessStatus.UNKNOWN) {
          <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalAttachment()">Anhang hochladen</button>
        }
      </div>
    }
    @if (process.status === ProcessStatus.DRAFT || process.status === ProcessStatus.OLD && process.username === webAuthService.authUser?.username && !edit) {
      <div class="my-4 no-print">
        @if (process.status === 'DRAFT' && !edit) {
          <button style="min-width: 130px" class="btn btn-sm btn-primary" (click)="editProcess()"><i class="fas fa-edit"></i>&ensp;Bearbeiten</button>
        }
        <button style="min-width: 130px" class="ms-3 btn btn-sm btn-primary" (click)="openModal()"><i class="fas fa-times"></i>&ensp;Löschen</button>
      </div>
    }
    @if (process.username === webAuthService.authUser?.username && (process.status === ProcessStatus.SENT || (process.status === ProcessStatus.APPROVED && process.formAllowCancelUntilProgressStarts && !process.approvals?.length))) {
      <div class="my-4 no-print">
        <button style="min-width: 130px" class="ms-3 btn btn-sm btn-primary" (click)="openModalCancel()"><i class="fas fa-times"></i>&ensp;Stornieren</button>
      </div>
    }
    @if (!edit) {
      <div class="form-check text-end mb-3">
        <input class="form-check-input float-none me-2" type="checkbox" id="onlyRelevantFields" [(ngModel)]="onlyRelevantFields" (ngModelChange)="saveOnlyRelevantFields()">
        <label for="onlyRelevantFields" class="form-check-label">Nur relevante Felder anzeigen</label>
      </div>
      @if (employee) {
        <app-approver-list-user-view [process]="process" [employee]="employee" [form]="form"/>
        <app-process-preview [process]="process" [onlyRelevanteFields]="onlyRelevantFields"/>
      }
    } @else {
      <app-form [existingProcess]="process" [form]="form" [isPreview]="false"/>
    }
    @if (!employee) {
      <div class="text-center m-auto mt-5">
        <rbb-loader/>
        <small class="text-secondary d-block">Antrag wird geladen...</small>
      </div>
    }
    @if (!edit) {
      <div class="row no-print">
        <div class="col-12 text-end">
          <button class="btn btn-primary me-2 mb-4" (click)="openModalPrivacyPolicy()"><i class="fas fa-user-shield" aria-hidden="true"></i>&ensp;Datenschutzerklärung</button>
          <span class="me-2 d-inline-block" data-bs-toggle="tooltip" data-bs-placement="top" [title]="process.latestFormId ? '' : 'Formular wurde von der Fachabteilung deaktiviert oder gelöscht.'">
            @if (employee && employee.username === process.username && employee.uidNumber === process.uidNumber) {
              <button class="btn btn-primary mb-4" [disabled]="!process.latestFormId" routerLink="/form/{{process.latestFormId}}" [queryParams]="{fill: process.id}"><i class="far fa-clone" aria-hidden="true"></i>&ensp;Kopieren und erneut ausfüllen</button>
            }
          </span>
          <button class="btn btn-primary mb-4" (click)="createPdf()"><i class="far fa-file-pdf" aria-hidden="true"></i>&ensp;PDF erstellen</button>
        </div>
      </div>
    }
  </div>
}

<ng-template #ngModalApprove>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      @if (isActiveApproval.length && isActiveApproval[0].forInformationOnly) {
        Antrag zur Kenntnis nehmen
      } @else {
        {{decline ? 'Antrag ablehnen' : 'Antrag genehmigen'}}
      }
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        @if (isActiveApproval.length && isActiveApproval[0].forInformationOnly) {
          <p>Wollen Sie den Antrag zur Kenntnis nehmen?</p>
        } @else {
          <p>Wollen Sie den Antrag wirklich {{decline ? 'ablehnen' : 'genehmigen'}}?</p>
        }
      </div>
    </div>
    <label class="form-label text-secondary">Kommentar @if (!decline) {(optional)}</label>
    <div class="input-group input-group-sm mb-3">
      <label class="input-group-text" for="approvalComment"><i class="far fa-comment" aria-hidden="true"></i></label>
      <textarea rows="3" class="form-control" id="approvalComment" name="approvalComment" [(ngModel)]="comment"></textarea>
    </div>

  </div>
  <div class="modal-footer pb-2 pt-2">
    @if (decline) {
      <button (click)="declineProcess()" class="btn btn-danger btn-sm" type="button" [disabled]="comment.length < 2"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Ablehnen</button>
    } @else {
      <button (click)="acceptProcess()" class="btn btn-success btn-sm" type="button"><i class="fas fa-check" aria-hidden="true"></i>&ensp;{{ isActiveApproval.length && isActiveApproval[0].forInformationOnly ? 'Zur Kenntnis nehmen' : 'Genehmigen' }}</button>
    }
    <button (click)="closeModalApprove()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>

<ng-template #ngModalResubmit>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">Wiedervorlage</h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <input class="form-control form-control-sm" type="date" [(ngModel)]="resubmit">
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="setResubmit()" class="btn btn-success btn-sm" type="button">Wiedervorlage setzen</button>
    @if (process?.resubmitted) {
      <button (click)="removeResubmit()" class="btn btn-danger btn-sm" type="button" >Wiedervorlage entfernen</button>
    }
    <button (click)="closeModalResubmit()" class="btn btn-secondary btn-sm" type="button">Abbrechen</button>
  </div>
</ng-template>

<ng-template #ngModalOperator>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      @switch (process?.status) {
        @case (ProcessStatus.APPROVED) {In Bearbeitung versetzen}
        @case (ProcessStatus.IN_PROGRESS) {Bearbeitung abschließen}
      }
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>
          @switch (process?.status) {
            @case (ProcessStatus.APPROVED) {Wollen Sie dieses Formular wirklich in Bearbeitung versetzen?}
            @case (ProcessStatus.IN_PROGRESS) {Wollen Sie die Bearbeitung dieses Formular wirklich abschließen?}
          }
        </p>
      </div>
      <div class="col-12">
        <label class="form-label text-secondary">Kommentar (optional)</label>
        <div class="input-group input-group-sm mb-3">
          <label class="input-group-text" for="progressComment"><i class="far fa-comment" aria-hidden="true"></i></label>
          <textarea rows="3" class="form-control" id="progressComment" name="progressComment" [(ngModel)]="comment"></textarea>
        </div>
      </div>
      <div class="col-12">
        <label class="form-label text-secondary">Anhang (optional)</label>
        <div class="input-group input-group-sm mb-3">
          <input type="file" class="form-control" id="progressFile" accept=".pdf" (change)="fileSelected($event)" autocomplete="off">
        </div>
        <div class="small">
          Es dürfen nur PDF Dateien angehangen werden. Anhänge können nach dem Hochladen nicht mehr gelöscht werden.
        </div>
        @if (fileError) {
          <div class="text-center text-danger">
            {{fileError}}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    @switch (process?.status) {
      @case (ProcessStatus.APPROVED) {
        <button (click)="setInProgressProcessWithAttachment()" class="btn btn-success btn-sm" type="button">In Bearbeitung versetzen{{data ? ' und Anhang hochladen' : ''}}</button>
      }
      @case (ProcessStatus.IN_PROGRESS) {
        <button (click)="setFinishedWithAttachment()" class="btn btn-success btn-sm" type="button" >Bearbeitung abschließen{{data ? ' und Anhang hochladen' : ''}}</button>
      }
    }
    <button (click)="closeModalOperator()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>

<ng-template #ngModalReject>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      Bearbeitung des Antrags zurückweisen
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie die Bearbeitung des Antrags wirklich zurückweisen?</p>
      </div>
      <div class="col-12">
        <label class="form-label text-secondary">Kommentar</label>
        <div class="input-group input-group-sm mb-3">
          <label class="input-group-text" for="rejectionComment"><i class="far fa-comment" aria-hidden="true"></i></label>
          <textarea rows="3" class="form-control" id="rejectionComment" name="rejectionComment" [(ngModel)]="comment"></textarea>
        </div>
      </div>
      <div class="col-12">
        <label class="form-label text-secondary">Anhang (optional)</label>
        <div class="input-group input-group-sm mb-3">
          <input type="file" class="form-control" id="rejectFile" accept=".pdf" (change)="fileSelected($event)" autocomplete="off">
        </div>
        <div class="small">
          Es dürfen nur PDF Dateien angehangen werden. Anhänge können nach dem Hochladen nicht mehr gelöscht werden.
        </div>
        @if (fileError) {
          <div class="text-center text-danger">
            {{fileError}}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="setRejectedWithAttachment()" class="btn btn-danger btn-sm" type="button" [disabled]="comment.length < 2"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Zurückweisen{{data ? ' und Anhang hochladen' : ''}}</button>
    <button (click)="closeModalReject()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>

<ng-template #ngModalAttachment>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">Anhang hochladen</h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <label class="form-label text-secondary">Anhang</label>
        <div class="input-group input-group-sm mb-3">
          <input type="file" class="form-control" id="attachmentFile" accept=".pdf" (change)="fileSelected($event)" autocomplete="off">
        </div>
        <div class="small">
          Es dürfen nur PDF Dateien angehangen werden. Anhänge können nach dem Hochladen nicht mehr gelöscht werden.
        </div>
        @if (fileError) {
          <div class="text-center text-danger">
            {{fileError}}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="createAttachment()" [disabled]="!data" class="btn btn-success btn-sm" type="button">Anhang hochladen</button>
    <button (click)="closeModalAttachment()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>


<ng-template #ngModalCancel>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Antrag stornieren</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie den Antrag wirklich stornieren?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="cancelProcess()" class="btn btn-danger btn-sm">Stornieren</button>
    <button (click)="closeModalCancel()" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>


<ng-template #ngModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Entwurf löschen</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie den Entwurf wirklich unwiderruflich löschen?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="deleteProcess()" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt" aria-hidden="true"></i>&ensp;Löschen</button>
    <button (click)="closeModal()" class="btn btn-secondary btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Schließen</button>
  </div>
</ng-template>

<ng-template #ngModalPrivacyPolicy>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Datenschutzerklärung</span>
    </h5>
    <button type="button" class="btn-close" (click)="closeModalPrivacyPolicy()"></button>
  </div>
  <div class="modal-body p-3">
    <app-privacy-policy [process]="process"/>
  </div>
</ng-template>
